import { GenericLazyString } from '@eventbrite/i18n';
import interpolate from '@eventbrite/interpolate-lazy-string';
import findKey from 'lodash/findKey';
import React from 'react';
import { PROMO_CODE_TYPES } from '../../constants';
import getTerminology from '../../utils/terminology';
import { CTA_TEXTS, DISCOUNT_CODE_SUCCESS_MESSAGES, STATUS } from './constants';
import { PromoCodeCtaButton } from './PromoCodeCtaButton';
import { PromoCodeCtaText } from './PromoCodeCtaText';

export const getCtaText = (status: string) => CTA_TEXTS[status];
export const getStatus = (props: any) =>
    findKey(STATUS, (_value, key) => STATUS[key](props));

export const getPromoCodeSuccessMessageText = ({
    promoCode,
    promoCodeType,
    percentOff,
    amountOff,
    numPromoCodeTickets,
    isRegEvent = false,
}: {
    promoCode: string;
    promoCodeType: string;
    percentOff: string;
    amountOff: string;
    numPromoCodeTickets: number;
    isRegEvent?: boolean;
}) => {
    const accessCodeMessages =
        getTerminology(isRegEvent).accessCodeSuccessMessages;
    let successMessage: GenericLazyString | string =
        DISCOUNT_CODE_SUCCESS_MESSAGES.default;

    if (promoCodeType === PROMO_CODE_TYPES.ACCESS) {
        successMessage = accessCodeMessages(numPromoCodeTickets);
    } else if (percentOff) {
        successMessage = DISCOUNT_CODE_SUCCESS_MESSAGES.percentOff;
    } else if (!percentOff && amountOff) {
        successMessage = DISCOUNT_CODE_SUCCESS_MESSAGES.amountOff;
    }
    return interpolate(
        successMessage,
        { promoCodeHtml: promoCode, percentOff, amountOff },
        true,
    );
};

export const getInternalCta = ({
    ctaText,
    isDisabled,
    isLoading,
    isSubmitFailed,
    onClick,
}: {
    ctaText: string;
    isDisabled: boolean;
    isLoading: boolean;
    isSubmitFailed: boolean;
    onClick: () => any;
}) =>
    isSubmitFailed ? null : (
        <PromoCodeCtaText
            isLoading={isLoading}
            isDisabled={isDisabled}
            ctaText={ctaText}
            onClick={onClick}
        />
    );

export const getExternalCta = ({
    isDisabled,
    onClick,
    shouldShowExternalCta,
}: {
    isDisabled: boolean;
    onClick: () => any;
    shouldShowExternalCta: boolean;
}) =>
    shouldShowExternalCta ? (
        <PromoCodeCtaButton isDisabled={isDisabled} onClick={onClick} />
    ) : null;
